import { all_routes } from '../../../../feature-module/router/all_routes'
export const logo = '/assets/img/logo-white-v2.webp'
export const logoColor = '/assets/img/logo-color.webp'
export const header = [
  {
    tittle: 'Home',
    base: 'home',
    showAsTab: false,
    separateRoute: false,
    route: all_routes.home,
    menu: [],
  },
  {
    tittle: 'Live Teaching',
    base: 'live',
    showAsTab: false,
    separateRoute: false,
    route: all_routes.liveTeaching,
    menu: [],
  },
  {
    tittle: 'E-Course',
    base: 'jadi-course',
    showAsTab: false,
    separateRoute: false,
    route: all_routes.jadiCourse,
    menu: [],
  },
  {
    tittle: 'CBT',
    base: 'jadi-ukom',
    showAsTab: false,
    separateRoute: false,
    route: all_routes.jadiUkom,
    menu: [],
  },
  {
    tittle: 'Corporate',
    base: '',
    showAsTab: false,
    separateRoute: false,
    route: 'https://corporate.jadipraktisi.com/ ',
    menu: [],
  },
  {
    tittle: 'Campus',
    base: 'program',
    showAsTab: false,
    separateRoute: false,
    route: all_routes.program,
    menu: [
      {
        menuValue: 'UKOM',
        hasSubRoute: false,
        showSubRoute: false,
        showAsTab2: false,
        route: 'https://campus.jadipraktisi.com/',
      },
      {
        menuValue: 'JPOC',
        hasSubRoute: false,
        showSubRoute: false,
        showAsTab2: false,
        route: 'https://campus.jadipraktisi.com/',
      },
      {
        menuValue: 'Smart Pharmacy Edu',
        hasSubRoute: false,
        showSubRoute: false,
        showAsTab2: false,
        route: 'https://spe.jadipraktisi.com/',
      },
    ],
  },
]
